export default {"src":"/_next/static/media/customer_service.d0b3b17e.svg","height":78,"width":77,"blurWidth":0,"blurHeight":0};